var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44476",
    "data-name": "Group 44476",
    transform: "translate(3841 3861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49323",
    "data-name": "Path 49323",
    d: "M22,0A22,22,0,1,1,0,22,22,22,0,0,1,22,0Z",
    transform: "translate(-3841 -3861)",
    fill: "#f7931a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49324",
    "data-name": "Path 49324",
    d: "M1015.814,723.6c.424-2.837-1.736-4.362-4.689-5.38l.958-3.843-2.339-.583-.933,3.742c-.615-.153-1.246-.3-1.874-.441l.939-3.766-2.338-.583-.959,3.842c-.509-.116-1.009-.23-1.494-.351l0-.012-3.226-.806-.622,2.5s1.736.4,1.7.422a1.245,1.245,0,0,1,1.09,1.361l-1.091,4.378a1.9,1.9,0,0,1,.243.078l-.247-.061-1.53,6.133a.851.851,0,0,1-1.072.556c.023.034-1.7-.424-1.7-.424l-1.161,2.678,3.044.759c.566.142,1.121.291,1.668.43l-.968,3.887,2.337.583.959-3.846c.638.173,1.258.333,1.864.484l-.956,3.828,2.339.583.968-3.88c3.989.755,6.989.451,8.251-3.158,1.017-2.905-.051-4.581-2.149-5.673a3.731,3.731,0,0,0,2.987-3.435h0Zm-5.345,7.495c-.723,2.905-5.614,1.335-7.2.941l1.285-5.15c1.586.4,6.671,1.179,5.915,4.209Zm.724-7.537c-.66,2.643-4.73,1.3-6.051.971l1.165-4.671c1.321.329,5.573.944,4.887,3.7Z",
    transform: "translate(-4824.47 -4564.75)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.29ca0166943f4faa3ba2df68f89cc444.svg";
export { ForwardRef as ReactComponent };